const React = require('react')
const ReactDOM = require('react-dom')
const App = require('./app')

ReactDOM.render(
  <App />,
  document.getElementById('app')
)
